import {
  DROPDOWN_SELECT_GLOBAL,
  DROPDOWN_SELECT_GLOBAL_LIMPIAR,
  DROPDOWN_SELECT_CM,
  DROPDOWN_SELECT_CM_LIMPIAR,
  DROPDOWN_SELECT_E,
  DROPDOWN_SELECT_E_LIMPIAR,
  DROPDOWN_SELECT_L,
  DROPDOWN_SELECT_L_LIMPIAR,
  DROPDOWN_SELECT_MILABO,
  DROPDOWN_SELECT_MILABO_LIMPIAR,
  DROPDOWN_SELECT_MI_INFORME,
  DROPDOWN_SELECT_MI_INFORME_LIMPIAR,
  DROPDOWN_SELECT_R,
  DROPDOWN_SELECT_R_LIMPIAR,
  DROPDOWN_SELECT_USER_PT,
  DROPDOWN_SELECT_MI_MEDICO,
  DROPDOWN_SELECT_MI_MEDICO_ESP,
  DROPDOWN_SELECT_MI_MEDICO_LIMPIAR,
  DROPDOWN_SELECT_PT_LIMPIAR,
  DROPDOWN_LIMPIAR,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import selectDropDownInitialState from "../initialStates/selectDropDownState";


const selectDropDown = (state, { payload, type }) => {
  switch (type) {
    case DROPDOWN_SELECT_GLOBAL:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          selectGlobal: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_GLOBAL_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          selectGlobal: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_CM:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          consulMedica: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_CM_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          consulMedica: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_E:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          estudios: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_E_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          estudios: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_L:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          laboratorio: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_L_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          laboratorio: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_R:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          recetaDigital: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_R_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          recetaDigital: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_MILABO:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misLaboratorio: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_MILABO_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misLaboratorios: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_MI_INFORME:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misInformes: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_MI_INFORME_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misInformes: {
            pacienteElegido: false,
          },
        },
      };
    case DROPDOWN_SELECT_USER_PT:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          proximosTurnos: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_PT_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          proximosTurnos: {
            pacienteElegido: false,
          },
        },
      };

    case DROPDOWN_SELECT_MI_MEDICO:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misMedicos: {
            pacienteElegido: payload,
          },
        },
      };
    case DROPDOWN_SELECT_MI_MEDICO_ESP:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misMedicos: {
            especialistas: payload,
          },
        },
      };
    case DROPDOWN_SELECT_MI_MEDICO_LIMPIAR:
      return {
        ...state,
        selectDropDown: {
          ...state.selectDropDown,
          misMedicos: {
            pacienteElegido: false,
            especialistas: null,
          },
        },
      };
      case DROPDOWN_LIMPIAR:
        return selectDropDownInitialState;
      case RESET_PORTAL_CONTEXT:
        return selectDropDownInitialState;
    default:
      return state;
  }
};

export default selectDropDown;
